<!-- 平台建单:紫金山 -->
<template>
  <div class="PlatformOrderCreation">
    <el-collapse v-model="activeName">
      <div class="title">
        <img
          src="@/assets/images/baseinfo.png"
          alt=""
        /><span class="title-text">紫金山建单</span>
      </div>
      <el-collapse-item name="1">
        <span
          class="order-title"
          slot="title"
        >
          {{$lang('商家任务单')}}
          <span
            class="total-view"
          >({{(taskList||[]).length||0}})</span>
        </span>
        <el-table :data="taskList" height="250" border v-loading="taskLoading">
          <template v-for="item in taskOption">
            <el-table-column
              align="center"
              :prop="item.prop"
              :label="$lang(item.label)"
              :key="item.prop"
              :width="item.width"
            >
            </el-table-column>
          </template>
          <el-table-column
            fixed="right"
            :label="$lang('操作')"
            width="60"
            v-if="isDisabled"
          >
            <template slot-scope="scope">
              <el-button
                @click="handlePush(scope.row)"
                type="text"
                size="small"
                >{{ $lang("推送") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
      <div class="create-order" v-if="isDisabled">
        <el-select
          v-model="createValue"
          :placeholder="$lang('请选择')"
          clearable
          :filterable="customerInfo.skillGroupCode ==='tikToknixiang'"
        >
          <el-option
            v-for="item in selectCreatedList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button
          class="create-btn"
          size="small"
          :type="createValue ? 'primary' : 'info'"
          :disabled="!createValue"
          :loading="btnLoading"
          @click="handleCreate"
          >{{ $lang("创建工单") }}</el-button
        >
      </div>
      <el-collapse-item style="margin-top: 5px;" :title="$lang('工单创建')" name="2">
        <span
          class="order-title"
          slot="title"
        >
          {{$lang('工单创建')}}
          <span
            class="total-view"
          >({{(createList||[]).length||0}})</span>
        </span>
        <el-table
          :data="createList"
          height="250"
          border
          v-loading="createLoading"
        >
          <template v-for="item in createOption">
            <el-table-column
              align="center"
              :prop="item.prop"
              :label="$lang(item.label)"
              :key="item.prop"
              :width="item.width"
            >
            </el-table-column>
          </template>
        </el-table>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import { platformOrderApi } from '../pool';
import debounce from 'lodash/debounce';

const statusObj = {
  UN_PUSHED: '未推送',
  PENDING: '待确认',
  CREATED: '已创建'
};
export default {
  name: 'PlatformOrderCreation',
  props: {
    customerInfo: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    customerInfo: {
      handler() {
        this.init();
      },
      deep: true
    }
  },
  data() {
    return {
      activeName: [],
      sessionId: '',
      taskList: [], // 商家任务单
      createList: [], // 工单创建列表
      selectCreatedList: [], // 工单创建下拉框
      createValue: '', // 工单创建下拉框选中值
      createLoading: false,
      taskLoading: false,
      btnLoading: false
    };
  },
  created() {
    this.init();
  },
  methods: {
    // 初始化
    init: debounce(function () {
      this.sessionId = this.customerInfo?.sessionId || ''
      if (!this.sessionId) return;
      this.activeName = []
      this.taskList = [];
      this.createList = [];
      this.selectCreatedList = [];
      this.createValue = '';
      this.getTaskList();
      this.getCreatedList();
    }, 500),
    // 获取商家任务单
    async getTaskList() {
      try {
        this.taskLoading = true;
        const { data = [] } = await platformOrderApi.reqTaskList(
          this.sessionId
        );
        this.taskList = [...data];
        this.taskList.length && this.activeName.push('1')
      } finally {
        this.taskLoading = false;
      }
    },
    // 工单创建
    async getCreatedList() {
      try {
        this.createLoading = true;
        const { data = [] } = await platformOrderApi.reqOrderList(
          this.sessionId
        );
        const list = data?.map((item) => {
          return {
            ...item,
            statusName: statusObj[item.status] || ''
          };
        });
        this.createList = list?.filter((item) => item.status !== 'UN_PUSHED');
        this.createList?.length && this.activeName.push('2')
        this.selectCreatedList = list?.filter(
          (item) => item.status === 'UN_PUSHED'
        );
      } finally {
        this.createLoading = false;
      }
    },
    // 推送
    async handlePush({ id }) {
      await platformOrderApi.reqPush({
        sessionId: this.sessionId,
        id
      });
    },
    // 创建工单
    async handleCreate() {
      if (!this.createValue || !this.sessionId) return;
      try {
        this.btnLoading = true;
        await platformOrderApi.reqPushOrder({
          sessionId: this.sessionId,
          id: this.createValue
        });
        this.getCreatedList();
      } finally {
        this.btnLoading = false;
      }
    }
  },
  computed: {
    // 是否可操作
    isDisabled() {
      return this.customerInfo.state === 'SESSION_ING';
    },
    // 商家任务单
    taskOption() {
      return [
        {
          label: 'ID',
          prop: 'taskId'
        },
        {
          label: '名称',
          prop: 'name'
        },
        {
          label: '类型',
          prop: 'typeName'
        },
        {
          label: '状态',
          prop: 'statusName'
        }
      ];
    },
    // 工单创建
    createOption() {
      return [
        {
          label: '工单类型',
          prop: 'name'
        },
        {
          label: '一级类型ID',
          prop: 'firstTypeId',
          width: 100
        },
        {
          label: '二级类型ID',
          prop: 'secondTypeId',
          width: 100
        },
        {
          label: '三级类型ID',
          prop: 'thirdTypeId',
          width: 100
        },
        {
          label: '创建时间',
          prop: 'createTime'
        },
        {
          label: '更新时间',
          prop: 'updateTime'
        },
        {
          label: '状态',
          prop: 'statusName'
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.PlatformOrderCreation {
  padding: 0px;
  ::v-deep .el-collapse-item__content {
    padding: 10px;
  }
  ::v-deep .el-collapse-item__wrap {
    border-bottom: none;
  }
  .create-order {
    margin: 15px 0px 5px 0px;
    .create-btn {
      display: inline-block;
      margin-left: 10px;
    }
    ::v-deep .el-input__inner {
      height: 32px !important;
    }
  }
  .title {
    font-weight: bold;
    padding-left: 10px;
    margin-bottom: 10px;
    img{
      vertical-align: middle;
      margin-right: 5px;
      width: 16px;
      height: 19px;
      margin-bottom: 3px;
    }
  }
  .title-text {
    position: relative;
  }
  .title-text::after {
    content: '*';
    display: block;
    position: absolute;
    color: #e60012;
    top: -2px;
    right: -7px;
  }
  ::v-deep .el-collapse-item {
    border-radius: 10px;
    overflow: hidden;
  }
  ::v-deep .el-collapse-item__header::before {
    display: none;
  }
  ::v-deep .el-collapse-item__header {
    font-weight: bold;
  }
}
::v-deep .uploadTips{
  top: 33px;
}
// ::v-deep .avue-group {
//   border: none !important;
// }
// ::v-deep .avue-form__group {
//   padding: 0;
// }
</style>
